export default __webpack_public_path__ + "static/media/showtime.5f335c75.png";